import { supabase } from './supabaseClient';

/**
 * Aktivite kaydı oluştur
 * @param {string} userId - Aktiviteyi gerçekleştiren kullanıcı ID'si
 * @param {string} taskId - İlgili görev ID'si
 * @param {string} activityType - Aktivite tipi ('create', 'update', 'delete', vs.)
 * @param {string} description - Aktivite açıklaması
 */
export const createActivity = async (userId, taskId, activityType, description) => {
  try {
    const { error } = await supabase
      .from('activities')
      .insert([
        {
          user_id: userId,
          task_id: taskId,
          activity_type: activityType,
          description: description
        }
      ]);

    if (error) throw error;
  } catch (error) {
    console.error('Aktivite kaydı oluşturma hatası:', error);
    throw error;
  }
};

/**
 * Görev aktivitelerini getir
 * @param {string} taskId - Görev ID'si
 */
export const getTaskActivities = async (taskId) => {
  try {
    const { data, error } = await supabase
      .from('activities')
      .select(`
        *,
        user_profiles:user_id (
          first_name,
          last_name,
          profile_photo_url
        )
      `)
      .eq('task_id', taskId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Aktivite kayıtları getirme hatası:', error);
    throw error;
  }
};

